import React from 'react';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PersonIcon from '@material-ui/icons/Person';
import SecurityIcon from '@material-ui/icons/Security';
import UsersIcon from '@material-ui/icons/Group';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import HistoryIcon from '@material-ui/icons/History';
import { SidebarAccordionItem } from '../Root/SidebarAccordionItem';
import DiamIcon from '../icons/DiamIcon';

const DIAM_ROUTES = [
  { to: '/diam/dashboard', label: 'Dashboard', icon: DashboardIcon },
  { to: '/diam/identities', label: 'Identities', icon: PersonIcon },
  { to: '/diam/roles', label: 'Roles', icon: SecurityIcon },
  { to: '/diam/teams', label: 'Teams', icon: UsersIcon },
  { to: '/diam/invitations', label: 'Invitations', icon: MailOutlineIcon },
  { to: '/diam/audit-logs', label: 'Audit logs', icon: HistoryIcon },
] as const;

export const DiamSidebarGroup = () => (
  <SidebarAccordionItem title="DIAM" icon={DiamIcon} routes={DIAM_ROUTES} />
);
